<template>
  <BNavbar toggleable="lg" type="dark" variant="primary" class="mb-4 header-navbar">
    <BContainer class="d-flex align-items-center">
      <BNavbarBrand href="#" class="me-auto">嘎嘎狗部落格</BNavbarBrand>

      <BNavbarToggle target="nav-collapse" class="ms-auto" />

      <BCollapse id="nav-collapse" is-nav>
        <!-- 搜尋框在手機尺寸時顯示在選單上方 -->
        <BForm class="d-flex d-lg-none mb-3">
          <BFormInput type="search" placeholder="搜尋..." class="me-2"></BFormInput>
          <BButton variant="light">搜尋</BButton>
        </BForm>

        <div class="d-flex w-100 justify-content-between align-items-center">
          <BNavbarNav class="me-auto">
            <BNavItem v-for="(menu, index) in filteredMenuOptions" :key="index" :href="menu.url">
              <a class="nav-link" :class="{ active: isActive(menu.url) }">{{ menu.text }}</a>
            </BNavItem>
          </BNavbarNav>

          <!-- 搜尋框在桌面尺寸時顯示在右側 -->
          <BForm class="d-none d-lg-flex">
            <BFormInput type="search" placeholder="搜尋..." class="me-2"></BFormInput>
            <BButton variant="light">搜尋</BButton>
          </BForm>
        </div>
      </BCollapse>
    </BContainer>
  </BNavbar>
</template>

<script setup>
import {
  BNavbar,
  BContainer,
  BNavbarBrand,
  BNavbarToggle,
  BCollapse,
  BNavbarNav,
  BNavItem,
  BForm,
  BFormInput,
  BButton,
} from "bootstrap-vue-next";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useAuthStore } from '@/stores/auth'

// 選單選項
const menuOptions = [
  { url: "/", text: "首頁", requireAuth: false, hideWhenAuth: false },
  { url: "/append", text: "新增", requireAuth: true, hideWhenAuth: false },
  { url: "/contact", text: "留言", requireAuth: false, hideWhenAuth: false },
  { url: "/about", text: "關於", requireAuth: false, hideWhenAuth: false },
  { url: "/login", text: "登入", requireAuth: false, hideWhenAuth: true },
  { url: "/logout", text: "登出", requireAuth: true, hideWhenAuth: false },
];

// 判斷當前路徑是否與選單項目匹配
const route = useRoute();

const isActive = (url) => {
  if ((url === "" || url === "/" || url === "/home") &&
    (route.path === "/" || route.path === "/home")) {
    return true;
  }
  return route.path === url;
};

const auth = useAuthStore()

// 過濾選單選項 (計算屬性)
const filteredMenuOptions = computed(() => {
  const isLoggedIn = auth.isLoggedIn;
  
  return menuOptions.filter((menu) => {
    // 如果需要登入才能顯示，但用戶未登入，則隱藏
    if (menu.requireAuth && !isLoggedIn) {
      return false;
    }
    // 如果登入後要隱藏，且用戶已登入，則隱藏
    if (menu.hideWhenAuth && isLoggedIn) {
      return false;
    }
    return true;
  });
});

</script>

<style>
.header-navbar {
  background-image: url("@/assets/images/header.jpg");
  background-size: cover;
  background-position: center;
  color: white;
}

.header-navbar .navbar-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.header-navbar .nav-link {
  color: #000 !important;
  /* 綠色 */
  font-weight: 500;
}

.header-navbar .nav-link:hover {
  color: #66bb6a !important;
  /* hover 時的淺綠色 */
}

.header-navbar .nav-link.active {
  color: #2e7d32 !important;
  /* active 時的深綠色 */
  font-weight: bold;
  text-decoration: underline;
}

.header-navbar .form-control {
  background-color: rgba(255, 255, 255, 0.9);
  /* 調整為更亮的白色背景 */
  border: none;
}

.header-navbar .btn {
  background-color: rgba(76, 175, 80, 0.8);
  /* 綠色按鈕背景 */
  color: #fff;
  /* 白色文字 */
  border: none;
}

.header-navbar .btn:hover {
  background-color: #66bb6a;
  /* hover 時的淺綠色 */
  color: #fff;
}

/* 確保手機版選單按鈕在最右邊 */
.header-navbar .navbar-toggler {
  margin-left: auto;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.header-navbar .container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

/* 手機版佈局調整 */
@media (max-width: 991.98px) {
  .header-navbar .container {
    justify-content: space-between;
  }
  
  .header-navbar .navbar-brand {
    flex: 0 0 auto;
  }
  
  .header-navbar .navbar-toggler {
    flex: 0 0 auto;
  }
}
</style>
